export type ProjectTileClickAction = "navigate" | "toggle-sidebar"
export type ProjectSidebarBadgeKind = "smartwork" | "workspace"

export function projectTileClickAction(input: {
  selected: boolean
  selectedProjectNavigates: boolean
}): ProjectTileClickAction {
  if (input.selected && !input.selectedProjectNavigates) return "toggle-sidebar"
  return "navigate"
}

export function projectSidebarBadgeKind(input: {
  smartworkCloudEnabled: boolean
  workspacesEnabled: boolean
}): ProjectSidebarBadgeKind | undefined {
  if (input.smartworkCloudEnabled) return "smartwork"
  if (input.workspacesEnabled) return "workspace"
}
